import { equals } from "angular";
import dayjs from "@gtmhub/dayjs";
import { CurrentUserService } from "@gtmhub/users";

export interface IWhiteboardsUserSettings {
  opened: IWhiteboardUserSettings[];
}

export interface IWhiteboardUserSettings {
  id: string;
  openedAt: string;
  zoom: number;
}

export class WhiteboardsUserSettingsService {
  static $inject = ["CurrentUserService"];

  constructor(private currentUserService: CurrentUserService) {}

  getOpened(): IWhiteboardUserSettings[] {
    return this.userSettings().opened;
  }

  update(whiteboardId: string, partialSettings: Partial<IWhiteboardUserSettings>): IWhiteboardUserSettings {
    const userSettings = this.userSettings();
    const existingWhiteboardSettings = userSettings.opened.find((w) => w.id === whiteboardId);
    if (!existingWhiteboardSettings) {
      const newWhiteboardSettings: IWhiteboardUserSettings = {
        id: whiteboardId,
        openedAt: dayjs.utc().format(),
        zoom: 100,
        ...partialSettings,
      };
      userSettings.opened.push(newWhiteboardSettings);
      this.currentUserService.setUserSetting({ whiteboards: userSettings });
      return newWhiteboardSettings;
    } else {
      if (!equals({ ...existingWhiteboardSettings, ...partialSettings }, existingWhiteboardSettings)) {
        const newWhiteboardSettings = Object.assign(existingWhiteboardSettings, partialSettings);
        this.currentUserService.setUserSetting({ whiteboards: userSettings });
        return newWhiteboardSettings;
      }
      return existingWhiteboardSettings;
    }
  }

  remove(whiteboardId: string): void {
    const userSettings = this.userSettings();
    const openedWhiteboardsCount = userSettings.opened.length;

    userSettings.opened = userSettings.opened.filter((w) => w.id !== whiteboardId);

    if (userSettings.opened.length !== openedWhiteboardsCount) {
      this.currentUserService.setUserSetting({ whiteboards: userSettings });
    }
  }

  private userSettings(): IWhiteboardsUserSettings {
    return this.currentUserService.getUserSetting<IWhiteboardsUserSettings>("whiteboards") || { opened: [] };
  }
}
